import React from 'react';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Radio, Button, Modal, Form, Row, Col, Icon, Input, Select, DatePicker, Spin, Popconfirm, Popover } from 'antd';
const FormItem = Form.Item;
const RangePicker = DatePicker.RangePicker;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
import { handleSearch, getTaskInfos, importDol, getExportUrl } from './action';
import { connect } from 'react-redux';
import { trunRangePicker } from './constant';
import moment from 'moment';
import './styles.css';


class StatisticView extends React.Component {

    constructor(props) {
        super(props);
        this.handleOnFieldsChange = this.handleOnFieldsChange.bind(this);
    }

    componentDidMount() {
        this.props.getTaskInfos(); //查询任务统计的echarts数据
        this.props.getExportUrl();
    }

    componentWillUnmount() {
        let _serach = this.props.search;
        let _obj = {};
        Object.keys(_serach).forEach((key, index) => {
            _obj[key] = '';
        });
        this.props.handleSearch(Object.assign(_obj, { 'time[0]': moment().format('YYYY-MM-DD')}));
    }

    handleOnFieldsChange(fields) {
        let _obj = {};
        Object.keys(fields).forEach((key, index) => {
            if (key === 'time') {
                _obj['time'] = fields[key].value;
                _obj['time[0]'] = moment(fields[key].value).format('YYYY-MM-DD');
            }
        });
        this.props.handleSearch(Object.assign(_obj));
        this.fieldsOnChangeImpl(fields);
    }

    fieldsOnChangeImpl(fields) {
        Object.keys(fields).forEach((key, index) => {
            if (key === 'time') {
              this.props.getExportUrl();
            }
        });
    }


    render() {

        const columns = [{
            title: '订单名称',
            width: '17%',
            dataIndex: 'taskDescription',
        }, {
            title: '广告位名称',
            width: '17%',
            dataIndex: 'taskName',
        }, {
            title: '任务ID',
            dataIndex: 'taskId',
            width: '4%',
            className : 'single',
            sorter: (a, b) => a.taskId - b.taskId,
        }, {
            title: '广告ID',
            width: '4%',
            dataIndex: 'adid',
        }, {
            title: '订单ID',
            className : 'single',
            width: '7%',
            dataIndex: 'orderId',
        },{
            title: 'PS',
            width: '3%',
            dataIndex: 'ps',
        }, {
            title: '投放平台',
            className : 'single',
            width: '3%',
            dataIndex: 'platform',
        }, {
            title: '类型',
            width: '5%',
            dataIndex: 'taskType',
            render:text => <p >{text==='EV'?"曝光":"点击"}</p>,
        }, {
            title: '营运目标量',
            className : 'single',
            width: '5%',
            dataIndex: 'targetPv',
        }, {
            title: '实际目标量',
            width: '5%',
            dataIndex: 'actual',
        }, {
            title: '广告已完成量',
            width: '5%',
            className : 'single',
            dataIndex: 'pv',
        }, {
            title: '恒紫已完成量',
            width: '5%',
            dataIndex: 'finishedPv',
        }, {
            title: '失败率(%)',
            dataIndex: 'failRate',
            width: '5%',
            className : 'single',
            render: (text, record) => <p style={{ color: record.highFailRate?'red':'' }} >{Number(text*100).toFixed(2)}</p>,
            sorter: (a, b) => a.failRate - b.failRate,
        }, {
            title: '已超期望率(%)',
            dataIndex: 'noGoalsRate',
            width: '5%',
            render: (text, record) => <p style={{ color: record.highNoGoalsRate?'red':'' }} >{Number(text*100).toFixed(2)}</p>,
            sorter: (a, b) => a.noGoalsRate - b.noGoalsRate,
            filters: [
                { text: '常规数据', value: false },
                { text: '标红数据', value: true },
            ],
            onFilter: (value, record) => record.highNoGoalsRate + "" === value,
        }, {
            title: '执行成功率(%)',
            width: '5%',
            dataIndex: 'execSucceedRate',
            className : 'single',
            render: (text, record) => <p style={{ color: record.lowExecSucceedRate?'red':'' }} >{Number(text*100).toFixed(2)}</p>,
            sorter: (a, b) => a.execSucceedRate - b.execSucceedRate,
            filters: [
                { text: '常规数据', value: false },
                { text: '标红数据', value: true },
            ],
            onFilter: (value, record) => record.lowExecSucceedRate + "" === value,
        }, {
            title: '任务完成率(%)',
            width: '5%',
            dataIndex: 'completeRate',
            render: (text, record) => <p style={{ color: record.lowcompleteRate ? 'red' : '' }} >{Number(text*100).toFixed(2)}</p>,
            sorter: (a, b) => a.completeRate - b.completeRate,
            filters: [
                { text: '常规数据', value: false },
                { text: '标红数据', value: true },
            ],
            onFilter: (value, record) => record.lowcompleteRate + "" === value,
        }];





        let { loading, execInfos } = this.props;
        let { todaySub = {}, infoGt900, infoLt900, allDay = [] } = execInfos;
        const {gt90 = 0, lt90 = 0} = todaySub;
        return (
            <div style={{ marginBottom: '20px' }}>
                <Spin spinning={loading} tip="加载中">
                    <Row style={{ marginTop: '10px', marginBottom: '10px' }}>
                        <SearchForm {...this.props} handleOnFieldsChange={this.handleOnFieldsChange} />
                    </Row>
                    <Row style={{ marginTop: '10px', marginBottom: '20px' }} >
                        <h3>执行概况</h3>
                        <Col>今日运营订单数:{todaySub && todaySub.orderNum}  ; 今日运营任务数:{todaySub && todaySub.taskNum}  ;</Col>
                        <Col>今日运营曝光量:{todaySub && todaySub.evTargetPv}  ; 今日曝光完成量:{todaySub && todaySub.evFinishedPv}  ;</Col>
                        <Col>今日运营点击量:{todaySub && todaySub.clickTargetPv}  ; 今日点击完成量:{todaySub && todaySub.clickFinishedPv}  ;</Col>
                        <Col>完成率:{todaySub && todaySub.completeRate}  ;</Col>
                    </Row>

                    <Row style={{ marginTop: '30px', marginBottom: '30px' }} >0到8:50任务 任务数：{todaySub &&todaySub.lt90} </Row>
                    <Table columns={columns} dataSource={infoLt900} pagination={false} scroll={{y: 500}} bordered />

                    <Row style={{ marginTop: '30px', marginBottom: '30px' }} >9:00以后任务 任务数：{todaySub && todaySub.gt90} </Row>
                    <Table columns={columns} dataSource={infoGt900} pagination={false} scroll={{y: 500}} bordered />

                    <Row style={{ marginTop: '30px', marginBottom: '30px' }} >0-24任务 </Row>
                    <Table columns={columns} dataSource={allDay} pagination={false} scroll={{y: 500}} bordered />

                </Spin >
            </div >
        );
    }
}

const mapStateToProps = state => ({
    loading: state.everydayExecInfo.loading,
    search: state.everydayExecInfo.search,
    execInfos: state.everydayExecInfo.execInfos,
    exportUrl: state.everydayExecInfo.url,
});

const mapDispatchToProps = dispatch => ({
    handleSearch: search => dispatch(handleSearch(search)),
    getTaskInfos: () => dispatch(getTaskInfos()),
    importDol: () => dispatch(importDol()),
    getExportUrl: () => dispatch(getExportUrl()),
});

export default connect(mapStateToProps, mapDispatchToProps)(StatisticView);

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.handleSearch = this.handleSearch.bind(this);
        this.importDol = this.importDol.bind(this);
    }

    //查询
    handleSearch(e) {
        e.preventDefault();
        this.props.getTaskInfos();
    }


    //查询
    importDol(e) {
        e.preventDefault();
        this.props.importDol();
    }


    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <h1 style={{ marginBottom: '20px' }}>任务完成概况</h1>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row >
                      <Col span={3} style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px',witdh:'25%'}}>
                            <Button style={{ float: 'right' }} type="primary" htmlType="submit">
                                刷新
                            </Button>
                            {/* <Button style={{ float: 'right' }} type="primary" onClick={this.importDol} >
                                导入dol
                            </Button> */}
                            <Popover content= {
                                getFieldDecorator('time')(
                                    <DatePicker defaultValue={moment()}  format='YYYY/MM/DD' />
                                )
                                }
                                title="请选择下载日期"
                                trigger="hover">
                              <Button style={{ float: 'right' }}  >
                                 <a href={this.props.exportUrl} download="filename">导出日报</a>
                              </Button>
                           </Popover>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}
const SearchForm = Form.create({
    onFieldsChange(props, fields) {
        props.handleOnFieldsChange(fields);
    },
    mapPropsToFields(props) {
        return {
            time: {
                value: props.search.time
            },
        }
    }
})(Search);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/everydayExecInfo/index.js